<template>
  <el-dialog
    :visible.sync="isShow"
    width="680px"
    :title="isEdit ? '编辑'+ titleName : '添加' + titleName"
    :close-on-click-modal="false"
    custom-class="yioks_alert"
  >
    <el-form
      v-if="!loading"
      ref="squadForm"
      :model="squadInfo"
      :rules="formRules"
      label-width="180px"
      style="height: 500px"
      class="demo-ruleForm">
      <vue-scroll :ops="ops">
        <el-row v-if="!isEdit">
          <el-col :span="22">
            <el-form-item label="管理单位" prop="organUuid">
              <el-select
                v-model.trim="squadInfo.organUuid"
                style="width: 100%"
                placeholder="请选择管理单位"
                @change="changeOrg">
                <el-option
                  v-for="item in selectOrganList"
                  :key="item.organUuid"
                  :value="item.organUuid"
                  :label="item.organShortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="22">
            <el-form-item label="管理单位" prop="organUuid" >
              <p style="padding-left: 12px">{{squadInfo.organShortName}}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isEdit">
          <el-col :span="22">
            <el-form-item label="精英机构" prop="youthUuid">
              <el-select
                v-model.trim="squadInfo.youthUuid"
                style="width: 100%"
                placeholder="请选择管理单位后再选择精英机构"
                @change="changeCenter(squadInfo.youthUuid)">
                <el-option
                  v-for="item in selectCenterList"
                  :key="item.uuid"
                  :value="item.uuid"
                  :label="item.youthShortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="22">
            <el-form-item label="精英机构" prop="youthUuid">
              <p style="padding-left: 12px">{{squadInfo.youthShortName}}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="学校等级" prop="schoolGrade">
              <el-select
                v-model="squadInfo.schoolGrade"
                placeholder="请选择学校等级"
                style="width: 100%">
                <el-option
                  v-for="(item,index) in schoolLevelList"
                  :key="index"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="合作学校名称" prop="schoolName">
              <el-input v-model.trim="squadInfo.schoolName" placeholder="请输入合作学校名称(100个字以内)" maxlength="100"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="球队性别" prop="squadGender">
              <el-select
                v-model="squadInfo.squadGender"
                placeholder="请选择球队性别"
                style="width: 100%"
                >
                <el-option label="男足" value="男足"></el-option>
                <el-option label="女足" value="女足"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="每周参加培训学员" prop="playerTeamNum">
              <el-input v-model.number="squadInfo.playerTeamNum" placeholder="请输入每周参加培训学员人数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="合作学校每周训练次数" prop="playerTrainNum">
              <el-input v-model.number="squadInfo.playerTrainNum" placeholder="请输入合作学校每周训练次数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="合作开始时间" prop="cooperationStartDate">
              <el-date-picker
                  v-model="squadInfo.cooperationStartDate"
                  type="month"
                  style="width: 100%"
                  placeholder="请选择合作开始时间"
                  value-format="timestamp"
                :picker-options="StartPickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="合作截止时间" prop="cooperationEndDate">
              <el-date-picker
                  v-model="squadInfo.cooperationEndDate"
                  type="month"
                  style="width: 100%"
                  placeholder="请选择合作截止时间"
                  value-format="timestamp"
                :picker-options="endPickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="合同及参训学员等文件" :error="uploadErroeMsg" :rules="{required: true}">
              <el-upload
                class="yioks-form-item"
                :action="uploadPath"
                :on-remove="handleRemoveFile"
                :before-upload="beforeUpload"
                :on-success="handleSuccessFiler"
                multiple
                :limit="9"
                :on-exceed="handleExceed"
                :file-list="uploadFileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <a style="color: #F56C6C;">合作合同文件、每周参训学员名单汇总表，并附购买保险名单、缴费记录、学员培训协议等，</a>
                  <a style="color: #666;">单个上传文件大小不能超过50M,最多上传9个文件。</a>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

      </vue-scroll>
    </el-form>
    <div v-if="!loading" class="tip">带 * 号的为必填项</div>
    <div v-if="!loading" class="dialog_btn_wrap">
      <el-button
        type="primary"
        style="margin-right:20px"
        :loading="addbtnLoading"
        @click="addSquadCount"
      >确认</el-button>
      <el-button type="danger" @click="isShow = false">取消</el-button>
    </div>
    <yioks-loading v-if="loading" style="height: 500px" />
  </el-dialog>
</template>

<script>
import formRules from '@/utils/formRules/school'
import { schoolLevelList } from '@/utils/yioks_data'
import { squadPlayerSex } from '@/utils/yioks_filter'
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
import school from '@/api/school'
import coach from '@/api/coach'
export default {
  name: 'index',
  components: {
    'UploadImg': () => import('@/components/UploadImg')
  },

  mixins: [formRules],
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    organList: {
      type: Array,
      required: false
    },
    centerList: {
      type: Array,
      required: false
    },
    addSquad: {
      type: Boolean,
      required: true
    },
    squad: {
      type: Object,
      required: false
    },
    squadUuid: {
      type: String,
      required: false
    },
//    squadGender: {
//      type: String,
//      required: true
//    }
  },
  data () {
    return {
      img: '',
      titleName : "合作学校",
      uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
      squadInfo: {
        schoolName: '',
        squadGender: '',
        youthShortName: '',
        organShortName: '',
        organUuid: '',
        youthUuid: '',
        uuid: '',
        schoolGrade: '',
        cooperationStartDate:'',
        playerTeamNum:'',
        playerTrainNum:'',
        cooperationEndDate:''
      },
      selectOrganList: [],
      selectCenterList: [],
      loading: false,
      addbtnLoading: false,
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      fileListChangedFlag: false,
      ops,
      schoolLevelList,
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], // 文件上传组件 - 文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件

    }
  },
  computed: {
    isShow: {
      get () {
        return this.addSquad
      },
      set (val) {
        this.$emit('update:addSquad', val)
      }
    },
    // 时间选择器
    endPickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          if (that.squadInfo.cooperationStartDate) {
            return time.getTime() < that.squadInfo.cooperationStartDate;
          } else {
            return false;
          }
        },
      };
    },
    // 时间选择器
    StartPickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          if (that.squadInfo.cooperationEndDate) {
            return time.getTime() > that.squadInfo.cooperationEndDate;
          } else {
            return false;
          }
        },
      };
    },
  },
  watch: {


  },
  created () {
    if (this.squadUuid) {
      this.getSquadInfo()
    }
    this.getOrganListAndCenterList()
  },
  methods: {
    // 文件上传超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多上传9个文件，本次上传已经超过了限制。`);
    },
    //  证明材料提交成功
    handleSuccessFiler(res, file) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        targetSecondlyUuid: this.targetUuid,
        stageUuid: this.stageUuid,
        fileType: suffix
      };
      if (this.isEdit) {
        this.uploadFileList_edit.push(fileObj);
      }
      this.uploadFileList.push(fileObj);
    },
    handleRemoveFile(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        this.uploadFileList = this.uploadFileList.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileList = this.uploadFileList.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
      if(this.isEdit) {
        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },
    // 上传文件检测
    beforeUpload(file) {
       const fileReg = /^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i
       const fileType = fileReg.test(file.name)
      const fileLimit = file.size / 1024 / 1024 < 50;
      if (!fileLimit) {
        this.$message.error("单个上传文件大小不能超过50M");
        return false;
      }
       if (!fileType) {
         this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件");
         return false;
       }
      return fileLimit;
    },
    getOrganListAndCenterList () {
      let data = this.uuid
      let request
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
      } else if (this.userRole === 'system' || this.userRole === 'admin') {
        request = coach.getCenterListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      }
      request(data).then((res) => {
        this.selectOrganList = res
        if (this.selectOrganList.length === 1) {
          this.squadInfo.organUuid = this.selectOrganList[0].organUuid
          this.squadInfo.organShortName = this.selectOrganList[0].organShortName
          this.selectCenterList = this.selectOrganList[0].youthList || []
          if (this.selectCenterList.length === 1) {
            this.squadInfo.youthUuid = this.selectCenterList[0].uuid
            this.squadInfo.youthShortName = this.selectCenterList[0].youthShortName
          }
        }
      })
    },
    getSquadInfo () {
      this.loading = true
      school.getSchoolInfo(this.squadUuid).then(res => {
        this.squadInfo = res.facilitySchool

        if (res.contractList && res.contractList.length) {
          this.uploadFileList = [];
          this.uploadFileList = res.contractList.map((item) => {
            const { fileName, fileUrl } = item;
            return {
              ...item,
              name: fileName,
              url: fileUrl
            };
          });
        }
        this.loading = false
      })
    },
    addSquadCount () {
      if(this.uploadFileList.length === 0){
        this.$message.error("请上传合作合同文件")
        return
      }
      this.$refs['squadForm'].validate(valid => {
        if (valid) {
          this.addbtnLoading = true
          let requestName = school.addSchool
          let requestData = {
            facilitySchool : {
              ...this.squadInfo
            },
            contractList:this.uploadFileList
          }
          // 编辑球队时，data 加上 uuid，接口名改变
          if (this.isEdit) {
            requestName = school.updataSquad
            requestData.facilitySchool.uuid = this.squadInfo.uuid
          }

          requestName(requestData).then(res => {
            this.addbtnLoading = false
            // 重复处理
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$emit('hideAddsquadDialog', false)

            }
          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }
      })
    },
    changeCenter (youthUuid) {
      this.squadInfo.youthShortName = this.selectCenterList.find(item => {
        return item.uuid === this.squadInfo.youthUuid
      }).youthShortName
      if (youthUuid) {
        // this.getLeaderList(youthUuid)
        this.$set(this.squadInfo, 'chiefCoachUuid', '')
        this.$set(this.squadInfo, 'leaderUuid', '')
        this.$set(this.squadInfo, 'list', [{ coachUuid: '', duty: '', master: false }])
      }
    },


    changeOrg () {
      this.$set(this.squadInfo, 'youthUuid', '')
      this.$set(this.squadInfo, 'youthShortName', '')
      if (this.squadInfo.organUuid) {
        this.squadInfo.organShortName = this.selectOrganList.find(item => {
          return item.organUuid === this.squadInfo.organUuid
        }).organShortName
        this.selectCenterList = this.selectOrganList.find(item => {
          return item.organUuid === this.squadInfo.organUuid
        }).youthList || []
        if (this.selectCenterList.length === 1) {
          this.squadInfo.youthUuid = this.selectCenterList[0].uuid
          this.squadInfo.youthShortName = this.selectCenterList[0].youthShortName
        }
      } else {
        this.selectCenterList = []
      }
    },

  }
}
</script>

<style scoped lang="stylus">
  .tip
    color red
    width 100%
    margin-left: 50px;
    word-break break-word
  .yioks-form-item
    width 400px
</style>
